<script lang="ts" setup>

const props = defineProps(['class'])
</script>
<template>
  <svg :class="props.class" width="20" height="14" viewBox="0 0 20 14"  xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 8.15886H4.01672L8.28287 12.3611L6.61909 14L0 6.9984L6.61909 0L8.28287 1.63887L4.01672 5.84114H20V8.15886Z"
      fill="currentColor"
    />
  </svg>
</template>
